import { gql } from '@apollo/client'

export const MARK_ACHIEVEMENTS_AS_SEEN = gql`
  mutation markAchievementAsSeen($achievementIds: [ID!]!) {
    markAchievementsAsSeen(achievementInstanceIds: $achievementIds) {
      success
    }
  }
`
